var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppointmentBookingGoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5.75h-5.25v-2A.25.25 0 0022 3.5h-1.75a.25.25 0 00-.25.25v2h-8v-2a.25.25 0 00-.25-.25H10a.25.25 0 00-.25.25v2H4.5c-.553 0-1 .447-1 1V27.5c0 .553.447 1 1 1h23c.553 0 1-.447 1-1V6.75c0-.553-.447-1-1-1zm-1.25 20.5H5.75V14.375h20.5V26.25zm-20.5-14V8h4v1.5c0 .137.113.25.25.25h1.75A.25.25 0 0012 9.5V8h8v1.5c0 .137.113.25.25.25H22a.25.25 0 00.25-.25V8h4v4.25H5.75z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/appointment-booking-goal.23dc93a79fe59bd0f126a83660bb583e.svg";
export { SvgAppointmentBookingGoal as ReactComponent };